import { lazy } from "react";
// Membership Analytics Module (Module J — BillingV2 Stage 2)
// Roster intelligence: growth, churn and plan mix.

const MembershipAnalyticsPage = lazy(() => import("./pages/MembershipAnalyticsPage"));
// Export routes for AppRouter
export const membershipAnalyticsRoutes = [
  {
    path: "/membership-analytics",
    element: <MembershipAnalyticsPage />,
  },
];

// Export components for external use
